/// <reference path='../../../typings/browser.d.ts' />

namespace Application.Controllers {
  'use strict';

  import ConnectionRoom = Models.ConnectionRoom;
    import IBlock = Application.Models.IBlock;
    import IStreamPipe = Application.Models.IStreamPipe;
    import INetworkNode = Application.Models.NetworkNode;
    import BlockTypeNaturalKey = Application.Models.BlockTypeNaturalKey;

    export interface IUsedBlocksModalScope extends ng.IScope {
    entity: Models.IEntity;
    modalClose: () => void;
    blocks: IBlock[];
    reTake: () => void;
    drop: () => void;
    loading: boolean;
    allowSelection: () => boolean;
    checkSelection: () => void;
    selected: boolean;
    error: boolean;
    errorMsg: string;
    selectAll: () => void;
    selectedAll: boolean;
  }

  /**
   * UsedBlocksController class
   */
  export class UsedBlocksController {
    public static templateURL: string =
      'decorators/modals/used-blocks-modal.html';
    public static ID: string = '#id-used-blocks-modal';
    public static $name: string = 'usedBlocksModalController';
    public selectedConnectionRoom: Models.IConnectionRoom;
    public matchedPipes: Models.IPipe[];
    public connectionRooms: ConnectionRoom[];
    protected cookieKey: string = 'flex_connectionroom_selectedroom';
    public static $inject: string[] = [
      '$scope',
      'close',
      '$interval',
      '$timeout',
      'entity',
      'streamPipeService',
      '$window',
      'blockService',
      'connectionRoomService',
      '$rootScope',
    ];

    private scope: IUsedBlocksModalScope;
    private $interval: ng.IIntervalService;
    private close: (parameters: ngModal.ICloseParameters) => void;

    /**
     * Constructor
     */
    constructor(
      $scope: IUsedBlocksModalScope,
      close: (parameters: ngModal.ICloseParameters) => void,
      $interval: ng.IIntervalService,
      $timeout: ng.ITimeoutService,
      entity: INetworkNode,
      private streamPipeService: Services.StreamPipeService,
      private $window: ng.IWindowService,
      private blockService: Services.BlockService,
      private connectionRoomService: Services.ConnectionRoomService,
      private $rootScope: Services.IFlexSettings,
      protected messageTranslationsService: Services.MessageTranslationsService,
      protected $cookies: ng.cookies.ICookiesService
    ) {
      this.scope = $scope;
      this.$interval = $interval;
      this.scope.entity = entity; //networkNode
      this.scope.blocks = entity.blocks;
      this.scope.selected = false;
      this.removeErrorMsg();
      this.scope.selectedAll = false;

      // TODO: needed to draw the modal, why?
      $timeout(() => {
        window.altair_admin_common_init();
      }, 500);

      this.close = close;

      this.scope.modalClose = (): void => {
        if(!this.scope.blocks) {this.close(undefined); return; }
        this.scope.blocks.forEach(block => block.selected = false);
        this.close(undefined);
      };

        this.scope.allowSelection = (): boolean => {
            let blocks = this.scope.blocks;
            if(!blocks) return;
            return blocks.length > 0
                && (blocks[0].blockType.naturalKey == BlockTypeNaturalKey.SRT_GW_TX_LSTN || blocks[0].blockType.naturalKey == BlockTypeNaturalKey.SRT_GW_RX_LSTN);
        };

      /**
       * when checking a box, enable or disable the retake button
       */
      this.scope.checkSelection = (): void => {
        this.scope.selected = this.scope.blocks.some((block) => {
          return block.selected == true;
        });
      };

        this.scope.drop = async (): Promise<void> => {
            this.showLoadingIcon();
            let selectedBlocks = this.scope.blocks.filter((block: IBlock) => {
                return block.selected == true;
            });
            try {
                selectedBlocks = await this.getConnRooms(selectedBlocks);

                for (const block of selectedBlocks) {
                    await this.connectionRoomService
                        .drop(block.connRooms[0], block.streamPipe[0].sinkBlockId, false);
                }
            } catch (e) {
                this.showError(e);
            }

            this.hideLoadingIcon();
            this.getStreamPipe(entity.blocks);
            $scope.$apply();
        };

        this.scope.selectAll = (): void => {
          if(!this.scope.blocks) return;
          this.scope.blocks.forEach( (block) => {
            block.selected = this.scope.selectedAll && block.streamPipe != undefined;
          });
          this.scope.checkSelection();
        }

        this.scope.reTake = async (): Promise<void> => {
            this.showLoadingIcon();
            let selectedBlocks = this.scope.blocks.filter((block: IBlock) => {
                return block.selected == true;
            });

            try {
                selectedBlocks = await this.getConnRooms(selectedBlocks);
                for (const block of selectedBlocks) {

                  await this.connectionRoomService.drop(block.connRooms[0], block.streamPipe[0].sinkBlockId, false);

                  await new Promise(resolve => setTimeout(resolve, 3000)); // sleep 3 seconds

                  const validation = await this.connectionRoomService.validateConnection(block.streamPipe[0].sourceBlockId, block.streamPipe[0].sinkBlockId, undefined);

                  if (validation.result === "OK" || validation.result === "WARNING") {
                    this.$rootScope.$broadcast("vars.connectionLocked", true);
                    await this.connectionRoomService.take(block.connRooms[0], block.streamPipe[0].sourceBlockId, block.streamPipe[0].sinkBlockId);
                    block.selected = false;
                  }
                }
            } catch (e) {
                this.showError(e);
            }

            this.hideLoadingIcon();
            this.getStreamPipe(entity.blocks);
            $scope.$apply();
        };

        this.getStreamPipe(entity.blocks);
    } // end constructor

    /**
     * Check if block belongs to a current stream pipe, if so,
     * get streamPipe and put in new streamPipe property in block.
     * @param blockList
     */
    public async getStreamPipe(blockList: IBlock[]) {
      if(!blockList) return;
      const connectedBlockIdList: number[] = blockList
        .filter((block) => {
          return block.blockConnections.some((connection) => {
            return connection.connected == true;
          });
        })
        .map((block) => {
          return block.id;
        });

      let pipes: IStreamPipe[][] = await this.streamPipeService.getStreamPipesByBlockList(
        connectedBlockIdList
      );

      let connectedBlocks: any = {};
      connectedBlockIdList.forEach((connectedBlockId, index) => {
        connectedBlocks[connectedBlockId] = pipes[index];
      });

      blockList.forEach(async (block) => {
        block.streamPipe = connectedBlocks[block.id];
        if (block.streamPipe && block.streamPipe[0]) {
          // we format href for using it in the view
          block.streamPipe[0].href = Common.Utils.idFromHref(
            block.streamPipe[0].href
          );
          block.streamPipe[0].sourceBlockName = (
            await this.getBlockName(block.streamPipe[0].sourceBlockId)
          ).name;
          block.streamPipe[0].sinkBlockName = (
            await this.getBlockName(block.streamPipe[0].sinkBlockId)
          ).name;
        }
      });
    }

    /**
     * Find Connection rooms for each block and asign this value to block
     * in a new property (connRooms)
     * Important: for the middle nodes to work, we take stream pipe source to get the room.
     * @param selectedBlocks
     */

    public async getConnRooms(selectedBlocks: IBlock[]) {
      const connRooms = await this.connectionRoomService.getAllConnRoomsPromise();
      selectedBlocks.forEach((block) => {
        block.connRooms = [];
        connRooms.forEach((room) => {
          if (
            room.blockHrefs.some((blockHref) => {
              // return blockHref.blockHref == block.id.toString();
              return blockHref.blockHref == block.streamPipe[0].sourceBlockId.toString();
            })
          ) {
            block.connRooms.push(room);
          }
        });
      });
      return selectedBlocks;
    }

    getBlockName(id: any): ng.IPromise<IBlock> {
      return this.blockService.findById(id);
    }

      /**
       * Shows the loading icon
       * @private
       */
      private showLoadingIcon() {
          this.scope.loading = true;
          this.removeErrorMsg();
      }

      /**
       * Hides the loading icon
       * @private
       */
      private hideLoadingIcon() {
          this.scope.loading = false;
      }

      /**
       * Shows the message from an error
       * @param e error. It should be an object with a "data" attribute. That attribute must contain a "message" attribute
       * @private
       */
      private showError(e: any) {
          this.scope.error = true;
          if (e.data) {
              this.scope.errorMsg = e.data.message;
          }
      }

      /**
       * Removes the error message
       * @private
       */
      private removeErrorMsg() {
          this.scope.error = false;
          this.scope.errorMsg = "";
      }
  }
}
